<template>
    <div class="weather-content">
      <div class="top">
        <div class="adress">
          <i class="icon-biao"></i>
          <span>长沙</span>
        </div>
        <div class="refresh">
          <span>9月24日 15:30 刚刚更新</span>
        </div>
      </div>
      <div class="center">
        <div class="head">
          <div class="degree">29°</div>
          <div class="text"><i class="icon icon-W0"></i><span>晴</span></div>
        </div>
        <div class="tmp">
          <div class="name">空气温度：</div>
          <div class="number">60%</div>
        </div>
        <div class="tmp">
          <div class="name">夜温温度：</div>
          <div class="number">15°</div>
        </div>
        <div class="desc">
          <div class="list list-flex">
            <div class="item">
              <span class="wea">空气质量</span>
              <span>0.1</span>
            </div>
            <div class="item">
              <span class="wea">PM2.5</span>
              <span>0.5</span>
            </div>
            <div class="item">
              <span class="wea">PM10</span>
              <span>0.8</span>
            </div>
            <div class="item">
              <span class="wea">臭氧浓度</span>
              <span>1.2</span>
            </div>
          </div>
          <!--<div class="other">空气质量：<span>0.1</span></div>-->
          <!--<div class="other">PM2.5：<span>0.5</span></div>-->
          <!--<div class="other">PM10：<span>0.8</span></div>-->
          <!--<div class="other">臭氧浓度：<span>1.2</span></div>-->
        </div>
        <div class="desc">
          <div class="name">未来7天天气变化</div>
          <div class="list">
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月1日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月2日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月3日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月4日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月5日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月6日</span>
            </div>
            <div class="item">
              <span class="wea">30°<em>晴</em></span>
              <div class="icon"><i class="icon-W0"></i></div>
              <span>9月7日</span>
            </div>
          </div>
        </div>
        <div class="desc" style="border-bottom: 0;">
          <div class="name">气象预警</div>
          <div class="text">桂东县气象台2019年9月24日XXX</div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "weatherTime",
    data(){
      return{

      }
    }
  }
</script>

<style scoped>
  .weather-content{
    background-color: #fff;
  }
  .weather-content .top {
    display: flex;
    align-content: space-between;
  }
  .weather-content .top .adress {
    display: flex;
    align-content: space-between;
    padding: 15px;
  }
  .weather-content .top .adress .icon-biao {
    display: block;
    width: 20px;
    height: 20px;
    background: url("../assets/icon-biao.png") no-repeat;
    background-size: 100% 100%;
  }
  .weather-content .top .adress span {
    font-size: 20px;
    color: #333;
  }
  .weather-content .top .refresh {
    flex: 1;
    padding: 15px;
    text-align: right;
  }
  .weather-content .top .refresh span {
    font-size: 14px;
    color: #333;
  }
  .weather-content .top .refresh .do {
    text-align: right;
  }
  .weather-content .top .refresh .do .icon-shuaxin {
    position: relative;
    top: 2px;
    display: inline-block;
    width: 14px;
    height: 14px;
  }
  .weather-content .center {
    padding: 50px 15px 15px 15px;
  }
  .weather-content .center .tmp {
    display: flex;
    align-content: flex-start;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
  }
  .weather-content .center .head {
    margin-bottom: 20px;
  }
  .weather-content .center .head .degree {
    font-size: 42px;
  }
  .weather-content .center .head .text {
    margin-top: 10px;
    display: flex;
  }
  .weather-content .center .head .text i {
    margin-right: 10px;
    width: 32px;
    height: 32px;
  }
  .weather-content .center .head .text span {
    line-height: 32px;
  }
  .weather-content .center .tmp .name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .weather-content .center .tmp .number {
    font-size: 16px;
    color: #666;
  }
  .weather-content .center .desc {
    overflow: hidden;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
  }
  .weather-content .center .desc .other {
    line-height: 24px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
  .weather-content .center .desc .other span {
    font-size: 16px;
    color: #333;
  }
  .weather-content .center .desc .name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .weather-content .center .desc .text {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }
  .weather-content .center .desc .list {
    margin-top: 10px;
    overflow: hidden;
  }
  .weather-content .center .desc .list .item {
    float: left;
    display: inline-block;
    margin: 5px 5px 10px 5px;
  }
  .weather-content .center .desc .list .item span {
    display: block;
    font-size: 14px;
    color: #666;
    text-align: center;
  }
  .weather-content .center .desc .list .item span.wea,
  .weather-content .center .desc .list .item span.wea em {
    font-style: inherit;
    font-size: 16px;
    color: #333;
  }
  .weather-content .center .desc .list .item .icon {
    display: block;
    width: 100%;
    text-align: center;
  }
  .weather-content .center .desc .list .item .icon i {
    display: block;
    margin: 5px auto;
    width: 32px;
    height: 32px;
  }
  .list-flex {
    display: flex;
    align-content: space-between;
  }
  .list-flex .item {
    float: none;
    flex: 1;
  }
  .list-flex .item span {
    font-size: 16px;
  }
  .list-flex .item span.wea {
    margin-bottom: 5px;
  }

  i.icon-W0 {
    background: url("../assets/weather/W0.png") no-repeat;
    background-size: 100%;
  }
  .icon-shuaxin {
    background: url("../assets/icon-shuaxin.png") no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/weatherTime.vue